import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

const REF_PATTERN = /Ref# ([A-Z0-9]{8})/;

function refIn(body: unknown): string | null {
  if (typeof body === 'string') return body.match(REF_PATTERN)?.[1] ?? null;
  if (body == null || typeof body !== 'object') return null;
  const record = body as Record<string, unknown>;
  for (const key of ['errorMessage', 'message', 'error']) {
    const value = record[key];
    if (typeof value === 'string') {
      const ref = value.match(REF_PATTERN)?.[1];
      if (ref) return ref;
    }
  }
  return null;
}

function logRef(ref: string, req: HttpRequest<unknown>, status: number, body: unknown): void {
  console.error(`Ref# ${ref} — ${req.method} ${req.urlWithParams} (${status})`, body);
}

export const errorRefInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> =>
  next(req).pipe(
    tap({
      next: event => {
        if (!(event instanceof HttpResponse)) return;
        const ref = refIn(event.body);
        if (ref) logRef(ref, req, event.status, event.body);
      },
      error: (error: unknown) => {
        if (!(error instanceof HttpErrorResponse)) return;
        const ref = refIn(error.error);
        if (ref) logRef(ref, req, error.status, error.error);
      }
    })
  );
